export default __webpack_public_path__ + "static/media/redux.a9567540.svg";